var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.whiteName.includes(_vm.$route.name))?_c('Header',{on:{"onQRCodeLoad":_vm.onQRCodeLoad}}):_vm._e(),_c('div',{staticClass:"iv-app-content",class:{'iv-all-height': _vm.$route.name === 'login',
      'iframe-layout' : _vm.$route.name === 'voiceAdviceList',
			'remove-margin':_vm.whiteName.includes(_vm.$route.name),
			'iv-remove-padding': _vm.removePaddingBottomRoutes.includes(_vm.routeName)}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }